import React, { useState, useEffect } from 'react';
import Markdown from "markdown-to-jsx";
import { makeStyles, Theme, createStyles, Typography, Card, CardContent, Icon } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: "16px",
            textAlign: "left",
        },
        img: {
            textAlign: "center",
            width: "80vw",
        },
        icon: {
            width: "1rem",
            height: "1rem",
            fontSize: "1rem",
        },
        card: {
            marginBottom: "16px",
        }
    })
);

interface CustomCardProps {
    children: JSX.Element
}

function CustomCard (props: CustomCardProps): JSX.Element {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardContent>
                {props.children}
            </CardContent>
        </Card>
    )
}

interface Props {
    url: string
}

function Document(props: Props) {

    const classes = useStyles()

    const [document, setDocument] = useState("")
    useEffect(()=>{
        console.log(props.url)
        const effect = async ()=>{
            if (props.url !== undefined) {
                const response = await fetch (props.url)
                if (response.ok) {
                    const markdown = await response.text()
                    if (markdown.startsWith("<!DOCTYPE html>")) {
                        setDocument(`<Card>\n\n# 404 NOT FOUND\n指定されたドキュメントは見つかりませんでした。\n\n</Card>`)
                    }
                    else {
                        setDocument(markdown)
                    }

                }
            }
        }
        effect()
    },[props.url])

    return (
        <div className={classes.root}>
            <Markdown options={{
                overrides: {
                    h1: {
                        component: Typography,
                        props: {
                            component: "h1",
                            variant: "h4",
                        }
                    },
                    h2: {
                        component: Typography,
                        props: {
                            component: "h2",
                            variant: "h5",
                        }
                    },
                    h3: {
                        component: Typography,
                        props: {
                            component: "h3",
                            variant: "h6",
                        }
                    },
                    p: {
                        component: Typography,
                        props: {
                            component: "p",
                            variant: "body1",
                        }
                    },
                    img: {
                        component: "img",
                        props: {
                            className: classes.img
                        }
                    },
                    Card: {
                        component: CustomCard,
                    },
                    Icon: {
                        component: Icon,
                        props: {
                            className: classes.icon
                        }
                    },
                }
            }}>
                {document}
            </Markdown>
        </div>
    )

}
export default Document;

